const apiUrl = "https://api.zabavnamesta.cz/api";
//const apiUrl = "https://egapi.anteres.cz/api";
//const apiUrl = "http://localhost:3001"
const shopUrl = "https://shop.zabavnamesta.cz";
export const config: any = {
    gamesUrl: `${apiUrl}/Game`, //`
    detailUrl: `${shopUrl}/Item/Details`, //`
    resultsUrl: `${apiUrl}/Result`,
    reviewsUrl: `${apiUrl}/gamereview`, //`
}